export enum AccountCreationErrorCode {
  Unknown,
  DuplicateUser,
  EmailInUse,
  NoEmail,
  EmailNotAllowed,
  UnitNotFound,
  InvalidEmailAddress
}

export function getTranslationCodeForError(
  errorCode?: AccountCreationErrorCode
) {
  switch (errorCode) {
    case AccountCreationErrorCode.DuplicateUser:
      return "residentadmin:errors.duplicateUser";
    case AccountCreationErrorCode.EmailInUse:
      return "residentadmin:errors.emailInUse";
    case AccountCreationErrorCode.NoEmail:
      return "residentadmin:errors.noEmail";
    case AccountCreationErrorCode.EmailNotAllowed:
      return "residentadmin:errors.emailNotAllowed";
    case AccountCreationErrorCode.UnitNotFound:
      return "residentadmin:errors.unitNotFound";
    case AccountCreationErrorCode.InvalidEmailAddress:
      return "residentadmin:errors.invalidEmailAddress";
    case AccountCreationErrorCode.Unknown:
    default:
      return "residentadmin:errors.unknown";
  }
}
